import api from "@/lib/api";
import { createCRUDApi } from "@/lib/api-factory";
import type {
  StaffLevel,
  StaffLevelCreate,
  StaffLevelUpdate,
} from "@/types/staff/api-types/staff-level-types";

export interface StaffLevelOption {
  value: string;
  label: string;
}

export const staffLevelsApi = createCRUDApi<StaffLevel, StaffLevelCreate, StaffLevelUpdate>(
  "/staff-levels"
);

export const staffLevelsOptionsApi = {
  async getStaffLevelOptions(): Promise<StaffLevelOption[]> {
    const response = await api.get<StaffLevelOption[]>("/staff-levels/options");
    return response.data;
  },
};
